import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - JWT 토큰 첨부
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 에러 처리
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const login = (email, password) => {
  return api.post('/auth/login', { email, password });
};

export const getMe = () => {
  return api.get('/auth/me');
};

// Dashboard API
export const getDashboard = () => {
  return api.get('/ea/dashboard');
};

// EA List API
export const getEaListInit = () => {
  return api.get('/ea/list/init');
};

export const searchEaList = (params) => {
  return api.post('/ea/list/search', params);
};

export const updateEaStatus = (data) => {
  return api.post('/ea/list/update', data);
};
export const getHistoryList = (params) => api.get('/history/search', { params });

// 그룹화된 히스토리 (EA + Login별 접속 횟수)
export const getHistoryGrouped = (params) => api.get('/history/grouped', { params });

// 특정 EA + Login의 상세 접속 기록
export const getHistoryDetail = (params) => api.get('/history/detail', { params });

export default api;
